module.exports = __webpack_public_path__ + "media/volvo/assets/images/masthead@3x-70b9a5c0b912e2838ed2c5360f757da0.png";